// extracted by mini-css-extract-plugin
module.exports = {"monthYearLabel":"DateTimeMonthYearLabel_monthYearLabel__nBM8g"};